"use strict";
"use client";

var _slicedToArray = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/slicedToArray.js")["default"];
var _objectSpread = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js")["default"];
var _objectWithoutProperties = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties.js")["default"];
var _classCallCheck = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/classCallCheck.js")["default"];
var _createClass = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/createClass.js")["default"];
var _callSuper = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/callSuper.js")["default"];
var _inherits = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/inherits.js")["default"];
var _createForOfIteratorHelper = require("/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js")["default"];
var _excluded = ["as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  InView: function InView() {
    return _InView;
  },
  defaultFallbackInView: function defaultFallbackInView() {
    return _defaultFallbackInView;
  },
  observe: function observe() {
    return _observe;
  },
  useInView: function useInView() {
    return _useInView;
  }
});
module.exports = __toCommonJS(src_exports);

// src/InView.tsx
var React = __toESM(require("react"));

// src/observe.ts
var observerMap = /* @__PURE__ */new Map();
var RootIds = /* @__PURE__ */new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function _defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== void 0;
  }).map(function (key) {
    return "".concat(key, "_").concat(key === "root" ? getRootId(options.root) : options[key]);
  }).toString();
}
function createObserver(options) {
  var id = optionsToId(options);
  var instance = observerMap.get(id);
  if (!instance) {
    var elements = /* @__PURE__ */new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _a;
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        });
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function _observe(element, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var fallbackInView = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : unsupportedValue;
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {};
  }
  var _createObserver = createObserver(options),
    id = _createObserver.id,
    observer = _createObserver.observer,
    elements = _createObserver.elements;
  var callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements["delete"](element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var _InView = /*#__PURE__*/function (_React$Component) {
  function _InView(props) {
    var _this;
    _classCallCheck(this, _InView);
    _this = _callSuper(this, _InView, [props]);
    __publicField(_this, "node", null);
    __publicField(_this, "_unobserveCb", null);
    __publicField(_this, "handleNode", function (node) {
      if (_this.node) {
        _this.unobserve();
        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: void 0
          });
        }
      }
      _this.node = node ? node : null;
      _this.observeNode();
    });
    __publicField(_this, "handleChange", function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        _this.unobserve();
      }
      if (!isPlainChildren(_this.props)) {
        _this.setState({
          inView: inView,
          entry: entry
        });
      }
      if (_this.props.onChange) {
        _this.props.onChange(inView, entry);
      }
    });
    _this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
    return _this;
  }
  _inherits(_InView, _React$Component);
  return _createClass(_InView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.unobserve();
      this.observeNode();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
        this.unobserve();
        this.observeNode();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unobserve();
    }
  }, {
    key: "observeNode",
    value: function observeNode() {
      if (!this.node || this.props.skip) return;
      var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay,
        fallbackInView = _this$props.fallbackInView;
      this._unobserveCb = _observe(this.node, this.handleChange, {
        threshold: threshold,
        root: root,
        rootMargin: rootMargin,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  }, {
    key: "unobserve",
    value: function unobserve() {
      if (this._unobserveCb) {
        this._unobserveCb();
        this._unobserveCb = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      if (typeof children === "function") {
        var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
        return children({
          inView: inView,
          entry: entry,
          ref: this.handleNode
        });
      }
      var _this$props2 = this.props,
        as = _this$props2.as,
        triggerOnce = _this$props2.triggerOnce,
        threshold = _this$props2.threshold,
        root = _this$props2.root,
        rootMargin = _this$props2.rootMargin,
        onChange = _this$props2.onChange,
        skip = _this$props2.skip,
        trackVisibility = _this$props2.trackVisibility,
        delay = _this$props2.delay,
        initialInView = _this$props2.initialInView,
        fallbackInView = _this$props2.fallbackInView,
        props = _objectWithoutProperties(_this$props2, _excluded);
      return React.createElement(as || "div", _objectSpread({
        ref: this.handleNode
      }, props), children);
    }
  }]);
}(React.Component);

// src/useInView.tsx
var React2 = __toESM(require("react"));
function _useInView() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    threshold = _ref.threshold,
    delay = _ref.delay,
    trackVisibility = _ref.trackVisibility,
    rootMargin = _ref.rootMargin,
    root = _ref.root,
    triggerOnce = _ref.triggerOnce,
    skip = _ref.skip,
    initialInView = _ref.initialInView,
    fallbackInView = _ref.fallbackInView,
    onChange = _ref.onChange;
  var _a;
  var _React2$useState = React2.useState(null),
    _React2$useState2 = _slicedToArray(_React2$useState, 2),
    ref = _React2$useState2[0],
    setRef = _React2$useState2[1];
  var callback = React2.useRef();
  var _React2$useState3 = React2.useState({
      inView: !!initialInView,
      entry: void 0
    }),
    _React2$useState4 = _slicedToArray(_React2$useState3, 2),
    state = _React2$useState4[0],
    setState = _React2$useState4[1];
  callback.current = onChange;
  React2.useEffect(function () {
    if (skip || !ref) return;
    var unobserve;
    unobserve = _observe(ref, function (inView, entry) {
      setState({
        inView: inView,
        entry: entry
      });
      if (callback.current) callback.current(inView, entry);
      if (entry.isIntersecting && triggerOnce && unobserve) {
        unobserve();
        unobserve = void 0;
      }
    }, {
      root: root,
      rootMargin: rootMargin,
      threshold: threshold,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
    return function () {
      if (unobserve) {
        unobserve();
      }
    };
  },
  // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [
  // If the threshold is an array, convert it to a string, so it won't change between renders.
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  var entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  var previousEntryTarget = React2.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  var result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  InView: _InView,
  defaultFallbackInView: _defaultFallbackInView,
  observe: _observe,
  useInView: _useInView
});